export default {"src":"/_next/static/media/down.4a6663fe.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};